import { useEffect, useState } from "react";

import { useLocation, useParams } from "react-router-dom";

import { useGetCareersData } from "../../../../hooks/misc";
import { useGetStudentDetails } from "../../../../hooks/students";

import { StudentInterviewsTab } from "../../../../interfaces/student";

import StudentDetailsLayout from "../../../layouts/Student";
import { TabContainer } from "../../../sub_components/Tabs";
import InterviewsTable from "../../../sub_components/tables/InterviewsTable";

const InterviewsList = () => {
    const location = useLocation();

    const { studentId: studentIdParam } = useParams();
    const studentId = studentIdParam ? parseInt(studentIdParam) : 0;

    const { data: student, isLoading: isStudentLoading } = useGetStudentDetails(studentId);
    const { data: careersData } = useGetCareersData(studentId);

    const interviewsData = careersData?.interviews || [];

    const tabItems = [
        { id: 'Audio', label: 'Audio' },
        { id: 'Video', label: 'Video' }
    ];

    const tab = location.state?.tab ?? null;

    const [currentTab, setCurrentTab] = useState<StudentInterviewsTab>('Audio');

    useEffect(() => {
        if (tab) setCurrentTab(tab);
    }, [tab]);

    useEffect(() => {
        const container = document.querySelector('.immersion__common_details__sub_info__forms_container');
        if (container) container.scrollTo(0, 0);
    }, [currentTab]);

    const handleTabChange = (tabId: string) => {
        setCurrentTab(tabId as StudentInterviewsTab);
    };

    const getInterviewsByTab = () => {
        if (currentTab === 'Audio') {
            return interviewsData.filter(interview => interview.mode === 'audio') || [];
        } else if (currentTab === 'Video') {
            return interviewsData.filter(interview => interview.mode === 'video') || [];
        }

        return [];
    }

    return (
        <StudentDetailsLayout
            goBackRoute={location.state?.goBackRoute ?? null}
            operation='update'
            currentTab="Interviews"
            title={student?.first_name + ' ' + student?.last_name}
            error={false}
            linkedStatus={{
                isDataAvailable: !!studentId,
                linked: !!student?.date_linked,
                linkedDate: student?.date_linked ?? null,
                unlinkedDate: student?.date_unlinked ?? null,
            }}
            isStudentAdded={!!student}
        >
            <div className="immersion__common_details__sub_info_container">
                <div className='immersion__common_details__sub_info_view'>
                    <TabContainer
                        items={tabItems}
                        activeTab={currentTab}
                        onChange={handleTabChange}
                        variant="content"
                    />
                    <div className="immersion__common_details__sub_info__forms_container">
                        <InterviewsTable
                            goBackRoute={location.state?.goBackRoute ?? null}
                            linked={true}
                            isLoading={isStudentLoading}
                            interviews={getInterviewsByTab()}
                        />
                    </div>
                </div>
            </div>
        </StudentDetailsLayout>
    );
};

export default InterviewsList;